import CompanyDashboardView from "@/views/company/dashboard/CompanyDashboardView";

export default [
  {
    name: "pages.company.dashboard",
    path: "dashboard",
    component: CompanyDashboardView
  },
  
  
];
